import React from 'react';
import { withRouter } from "react-router";

import './settings.scss';

class SettingsMenu extends React.Component {
    state = { isOverlayToggled: false, isWindowDisplayed: false }
    timer = null;

    componentDidUpdate(prevProps) {
        if (prevProps.isToggled !== this.props.isToggled) {
            this.setState({ isWindowDisplayed: this.props.isToggled }, () => {
                clearTimeout(this.timer);
                if (this.props.isToggled) {
                    this.setState({ isOverlayToggled: true });
                } else {
                    this.timer = setTimeout(() => this.setState({ isOverlayToggled: false }), 500);
                }
            })
        }
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.props.isToggled && this.props.hideDockedMenu();
        }
    }

    render() {
        var isMobile = window.innerWidth <= 992;

        return (<>
            <div
                className='docked-settings-menu-overlay'
                style={{
                    left: this.state.isOverlayToggled ? 0 : `${this.props.scrollWidth}px`,
                    backgroundColor: this.state.isWindowDisplayed ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0)',
                    display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
                }}
                onClick={_ => this.props.hideDockedMenu()} />
            <div className='docked-settings-menu' style={{
                left: this.state.isWindowDisplayed ? isMobile ? '20%' : `calc(${this.props.scrollWidth}px - 22em)` : `${this.props.scrollWidth}px`,
                width: isMobile ? 'auto' : "22em",
                display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
            }}>
                {this.props.children}
            </div>
        </>);
    }
}


export default withRouter(SettingsMenu);